module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SentMessageView.js"));
	}, "SentMessageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SentMessageView!./src/pages/MessageManage/SentMessage/SentMessageView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=SentMessageView!./src/pages/MessageManage/SentMessage/SentMessageView.js
// module chunks = 43